export const IMG = {
  hero: "https://images.pexels.com/photos/8422262/pexels-photo-8422262.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  learning:
    "https://images.unsplash.com/photo-1578349035260-9f3d4042f1f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxwcmVzY2hvb2wlMjBraWRzJTIwcGxheWluZyUyMGxlYXJuaW5nfGVufDB8fHx8MTc4Njk5MTIwNHww&ixlib=rb-4.1.0&q=85",
  outdoor:
    "https://images.unsplash.com/photo-1533222535026-754c501569dd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHw0fHxwcmVzY2hvb2wlMjBraWRzJTIwcGxheWluZyUyMGxlYXJuaW5nfGVufDB8fHx8MTc4Njk5MTIwNHww&ixlib=rb-4.1.0&q=85",
  staff:
    "https://images.unsplash.com/photo-1786293412015-1354a26b5955?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxjaGlsZGNhcmUlMjB0ZWFjaGVyJTIwY2xhc3Nyb29tJTIwaGFwcHl8ZW58MHx8fHwxNzg2OTkxMjA0fDA&ixlib=rb-4.1.0&q=85",
  parentApp:
    "https://images.pexels.com/photos/7484422/pexels-photo-7484422.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};
